
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's182ab2d6c997515f': `Aggiungilo alla schermata principale per un'esperienza più completa e un accesso facile.`,
's1b9047d53d9f9d22': `2) Premi Condividi nella barra di navigazione`,
's37a9e8aec5713460': `Più`,
's5c6aad7a7e4a1437': `3) Premi Aggiungi alla schermata principale`,
's6196153c4b0c1ea0': `Installa`,
's922329d6f6213590': `Aggiungi al Dock`,
'sa5ef80b4bb9b39f8': `Meno`,
'sa7551383d1897fcc': `2) Premi Aggiungi al Dock`,
'sba52286c21552a4e': `Installalo sul tuo dispositivo per un'esperienza più completa e un accesso facile.`,
'sc79fd7641eb9a975': `Nascondi istruzioni`,
'scdaf4bbff76674c8': `Aggiungi alla schermata principale`,
'sdfe23506a3b0cdc8': `1) Apri nel browser Safari`,
'se740f75b95a51807': `Aggiungilo al Dock per un'esperienza più completa e un accesso facile.`,
'sfea652f6580ff086': `Questo sito ha funzionalità di app.`,
    };
  